import { STORAGE_ITEMS } from "@config";
import { aPIPaths, handleResponse, methods, requestJSON, requestWithToken } from "@redux";

export const AuthServices = {
  startLogin,
  checkSca,
  selectIdentification,
  getIdentificationUrl,
  refreshToken
};

function startLogin(data) {
  return requestJSON(aPIPaths.startLogin, {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function checkSca(isWaitingRoom) {
  if (isWaitingRoom) {
    const token = localStorage.getItem(STORAGE_ITEMS.LOGIN_TOKEN);
    requestWithToken.defaults.headers["Authorization"] = `Bearer ${token}`;
    return requestWithToken(aPIPaths.checkSca).then(handleResponse);
  }
  const sessionToken = JSON.parse(sessionStorage.getItem("token") || {});
  requestWithToken.defaults.headers["Authorization"] = `Bearer ${sessionToken.token}`;
  return requestWithToken(aPIPaths.checkSca).then(handleResponse);
}

function selectIdentification(data) {
  return requestJSON(aPIPaths.selectIdentification, {
    method: methods.post,
    data: data
  }).then(handleResponse);
}

function getIdentificationUrl(language) {
  const queryParams = new URLSearchParams({ language });
  return requestJSON(`${aPIPaths.getIdentificationUrl}?${queryParams}`).then(handleResponse);
}

function refreshToken(token) {
  return requestJSON(aPIPaths.refreshToken + token).then(handleResponse);
}
